/**
 * useCookies - An SSR safe hook to provide the Cookies API.
 */
import {useMemo} from "react";

import {RenderState, useRenderState} from "@khanacademy/wonder-blocks-core";

import * as Cookies from "./cookies.ts";

export const useCookies = (): typeof Cookies | null => {
    const renderState = useRenderState();

    return useMemo(() => {
        // Wait until after the initial render on the client to check whether
        // the feature flag is set or not. This prevents rehydration errors.
        if (renderState === RenderState.Standard) {
            return Cookies;
        }
        return null;
    }, [renderState]);
};
